import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid, TextField, Button, CircularProgress } from '@material-ui/core';
import { useLocation, useNavigate } from 'react-router-dom';
import CheckIcon from '@material-ui/icons/Check';
import CustomBreadcrumbs from '../Breadcrumb';
import { doneRCA, getBreakdownDetails, } from '../../ReduxStore/Breakdown/BreakdownSlice';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import dayjs from 'dayjs';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import { convertUTCtoIST } from '../../helpers/DateConvert';



const WhyWhyAnalysis = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Breakdown Management', href: '/breakdown-management' },
        { label: 'Root Cause Analysis', href: '/breakdown-management/root-cause-analysis' },
    ];
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const breakdown_id = pathname[3];

    const [loading, setLoading] = useState(true);
    const [postLoading, setPostLoading] = useState(false);
    const [breakDownDetails, setBreakdownDetails] = useState();
    const Role = localStorage.getItem("userRole");

    const submitHandler = async () => {
        if (Role === 'admin' || Role === 'supplier') {
            const payload = {
                machine_breakdown_id: breakdown_id,
                customer_id: "af33f9117ecb4d8d8def84d6331eebd4",
                "rca": {
                    "other_fields": "other_fields"
                },
                status_id: "fbb69d283f8c4f61a1a6acc42c65d3c9" //close status id

            }
            try {
                setPostLoading(true)
                const action = dispatch(doneRCA(payload));
                const res = await action.unwrap();
                console.log("res", res.result)
                if (res.StatusCode === 201) {
                    setPostLoading(false)
                    toast.success("BreakDown RCA Successfully!");
                    setTimeout(() => {
                        navigate("/breakdown-management");
                    }, 2000);
                }
            } catch (error) {
                console.error("Error in okHandler:", error);
                toast.error(error.message || "Something went wrong!");
            } finally {
                setPostLoading(false)
            }
        } else {
            toast.info("You don't allow to do this activity!")
        }


    };


    const getbreakdownDetails = async () => {
        try {
            const action = dispatch(getBreakdownDetails(breakdown_id));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                setBreakdownDetails(res.result.breakdown)
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            await getbreakdownDetails();
            setLoading(false);
        };
        fetchData();
    }, [])



    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h5" component="h1" gutterBottom>
                        Why-Why Analysis
                    </Typography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Why-Why Analysis" />
                </Box>
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={2}>
                            Asset no.
                            <h4>{(breakDownDetails.machine_details.asset_no)?.slice(3)}</h4>
                        </Grid>
                        <Grid item xs={6} sm={4}>
                            Asset Description
                            <h4>{breakDownDetails.machine_details.asset_text}</h4>
                        </Grid>
                        {/* <Grid item xs={6} sm={2}>
                            RFID NO
                            <h4>{breakDownDetails.rfidNo}</h4>
                        </Grid> */}
                        <Grid item xs={6} sm={2}>
                            Part No
                            <h4>{breakDownDetails.machine_details?.material_no || "NA"}</h4>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={2}>
                            Nature
                            <h4>{breakDownDetails.reason.category_name}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            Priority
                            <h4>{breakDownDetails.priority}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            Failure Reason
                            <h4>{breakDownDetails.reason.name}</h4>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        {/* <Grid item xs={6} sm={2}>
                            Assigned by
                            <h4>{breakDownDetails.status_history[0].status_change_username}</h4>
                        </Grid> */}
                        {Object.keys(breakDownDetails.comments)
                            .filter(commentId => commentId !== 'user_names') // Filter out 'user_names'
                            .map((commentId) => {
                                const commentData = breakDownDetails.comments[commentId];
                                const userName = breakDownDetails.comments.user_names[commentId];
                                // Split the timestamp and comment
                                const [timestamp] = commentData.split(': ');

                                // Format the date using dayjs
                                // const formattedDate = dayjs(timestamp).format("DD MMM, YYYY hh:mm A");

                                return (
                                    <>
                                        <Grid item xs={6} sm={3} key={commentId}>
                                            Assigned by
                                            <h4>{userName}</h4>
                                        </Grid>
                                        <Grid item xs={6} sm={3} key={commentId}>
                                            Assigned at
                                            {/* <h4>{formattedDate}</h4> */}
                                            <h4>{convertUTCtoIST(timestamp)}</h4>
                                        </Grid>
                                    </>
                                );
                            })
                        }
                        {/* <Grid item xs={6} sm={2}>
                            Assigned at
                            <h4>{new Date(breakDownDetails.status_history[0].status_change_timestamp).toLocaleString()}</h4>
                        </Grid> */}
                        <Grid item xs={6} sm={3}>
                            Attended by
                            <h4>{breakDownDetails.attendance[0].attended_username}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            Attended at
                            {/* <h4>{dayjs(breakDownDetails.attendance[0].attended_timestamp).format("DD MMM, YYYY hh:mm A")}</h4> */}
                            <h4>{convertUTCtoIST(breakDownDetails.attendance[0].attended_timestamp)}</h4>
                        </Grid>
                    </Grid>

                </Box>
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Why 1"
                                name="why1"
                                type="text"
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Why 2"
                                name="why2"
                                type="text"
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Why 3"
                                name="why3"
                                type="text"
                                fullWidth
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Why 4"
                                name="why4"
                                type="text"
                                fullWidth
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Why 5"
                                name="why5"
                                type="text"
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Idea"
                                name="idea"
                                type="text"
                                fullWidth
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Corrective Action Inspection Side"
                                name="why2"
                                type="text"
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Containment Action"
                                name="why3"
                                type="text"
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Corrective Action Process side"
                                name="why4"
                                type="text"
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Sustainence Action"
                                name="why5"
                                type="text"
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ margin: '0 auto', maxWidth: '850px', marginBottom: "12px" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                style={{ borderRadius: "8px", fontSize: "16px", backgroundColor: "green" }}
                                onClick={submitHandler}
                                startIcon={postLoading ? <CircularProgress size={20} /> : <CheckIcon />}
                                disabled={postLoading}
                            >
                                {postLoading ? "Submitting" : "Submit"}
                            </Button>
                        </Grid>
                    </Grid>
                </Box>

            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default WhyWhyAnalysis;
